/* eslint-disable */
function defaultValue(value, dflt) {
  return undefined == value || null == value ? dflt : value;
}

function checkSum(string, weights, mod1, mod2) {
  mod1 = defaultValue(mod1, 11);
  mod2 = defaultValue(mod2, 10);
  var sum = 0;
  var i;
  for (i = 0; i < string.length; i += 1) {
    if (weights.length > i) {
      sum += parseInt(string.charAt(i), 10) * weights[i];
    }
  }
  sum %= mod1;
  sum %= mod2;
  return sum;
}

function checkSumINN(inn) {
  switch (inn.length) {
    case 10:
      var weights = [2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
      return '' + checkSum(inn, weights);
    case 12:
      var weights1 = [7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
      var weights2 = [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8, 0];
      return '' + checkSum(inn, weights1) + checkSum(inn, weights2);
  }
  return false;
}

export function validateINN(inn) {
  if (!inn) {
    return true;
  }
  // в ИНН только цифры
  if (inn.match(/[^0-9]/)) {
    return false;
  }
  var cksum = checkSumINN(inn);
  if (false !== cksum && cksum == inn.substr(inn.length - cksum.length)) {
    return true;
  }
  return false;
}

export function validateKPP(kpp) {
  return !kpp || /^[0-9]{4}[0-9A-Z]{2}[0-9]{3}$/.test(kpp);
}

export function validateOGRN(val, ogrnLen) {
  const numForRemainder = ogrnLen === 15 ? 13 : 11;
  const number = parseInt(val.slice(0, -1));
  const remainder = number % numForRemainder;
  const lastDigit = remainder.toString().slice(-1);
  const n13 = parseInt(lastDigit);
  if (n13 === parseInt(val[ogrnLen - 1])) {
    return true;
  }

  return false;
}
